import React, { RefAttributes } from 'react';
import { genericForwardRef, genericMemo } from '@direct-frontend/stdlib';
import { isMobile } from '@direct-frontend/platform-code';

import { ListBoxBase } from '../ListBoxBase/ListBoxBase';
import { cnListBox } from '../ListBoxBase/utils';
import { ListSection } from '../List/ListSection';

import { VirtualList, VirtualListProps } from './VirtualList/VirtualList';

/**
 * Компонент контейнер для построения виртуальных списков с выбором элементов
 * @deprecated используйте компонент VirtualList
 */
export const ListBoxVirtualized = genericMemo(
    genericForwardRef(function ListBoxVirtualized<ValueType extends string>(
        props: VirtualListProps<ValueType>,
        forwardedRef: React.ForwardedRef<HTMLDivElement>,
    ) {
        const {
            addonBefore,
            addonAfter,
            className,
            size,
            width = 'auto',
            style,
            displaySelection = true,
            items,
        } = props;

        return (
            <ListBoxBase
                size={isMobile() ? 'm' : size}
                width={width}
                style={style}
                displaySelection={displaySelection}
                className={cnListBox({ virtualized: true }, [className])}
            >
                {addonBefore}
                {props.pinnedSection ? (
                    <>
                        <ListSection>{props.pinnedSection}</ListSection>
                        {items.length !== 0 && <ListSection />}
                    </>
                ) : null}
                <VirtualList {...props} ref={forwardedRef} />
                {props.pinnedSectionAfter ? (
                    <>
                        {items.length !== 0 && !props.pinnedSection && <ListSection />}
                        <ListSection>{props.pinnedSectionAfter}</ListSection>
                    </>
                ) : null}
                {addonAfter}
            </ListBoxBase>
        );
    }),
);

export type ListBoxVirtualizedProps = VirtualListProps<string> & RefAttributes<HTMLDivElement>;
